import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonFrCA from './locales/fr-CA/common.json';
import commonEn from './locales/en/common.json';

// fr-CA is the primary/default UI language (FR-041); English is available as a
// secondary locale to keep the app i18n-ready (FR-042).
void i18n.use(initReactI18next).init({
  resources: {
    'fr-CA': { common: commonFrCA },
    en: { common: commonEn },
  },
  lng: 'fr-CA',
  fallbackLng: 'fr-CA',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
